interface StageCrewServiceWorkerRegistration {
  update(): Promise<void>;
}

interface StageCrewServiceWorkerContainer {
  register(scriptUrl: string): Promise<StageCrewServiceWorkerRegistration>;
  addEventListener(type: 'controllerchange', listener: () => void): void;
}

export interface StageCrewServiceWorkerRuntime {
  serviceWorker?: StageCrewServiceWorkerContainer;
  isLoaded(): boolean;
  onLoad(listener: () => void): void;
  reload(): void;
}

function browserRuntime(): StageCrewServiceWorkerRuntime {
  return {
    serviceWorker: typeof navigator !== 'undefined' && 'serviceWorker' in navigator
      ? navigator.serviceWorker
      : undefined,
    isLoaded: () => document.readyState === 'complete',
    onLoad: (listener) => window.addEventListener('load', listener, { once: true }),
    reload: () => window.location.reload(),
  };
}

export function registerStageCrewServiceWorker(
  runtime: StageCrewServiceWorkerRuntime = browserRuntime(),
): void {
  const { serviceWorker } = runtime;
  if (!serviceWorker) return;

  const register = () => {
    void serviceWorker.register('/sw.js')
      .then((registration) => registration.update())
      .catch(() => {
        // A failed optional cache layer must not prevent the live application
        // from loading or expose browser-specific failure details.
        console.warn('StageCrew service worker is unavailable for this session.');
      });
  };

  if (runtime.isLoaded()) {
    register();
  } else {
    runtime.onLoad(register);
  }

  let refreshing = false;
  serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    runtime.reload();
  });
}
